<template>
  <esg-base-chart max-width="500px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart type="donut"
                ref="chart"
                height="250"
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    colors: {
      type: Array,
      required: false,
    }
  },
  data() {
    return {
      loading: false,
      total: 0,
      categories: [],
      series: [],
      chartOptions: {
        labels: [],
        chart: {
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        dropShadow: {
          enabled: true,
          top: 1,
          left: 1,
          color: '#000',
          opacity: 0.7
        },
        xaxis: {
          categories: ['1'],
          labels: {
            show: false
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          x: {
            show: false
          },
          y: {
            formatter: val => {
              const percentage = this.formatNumber(100 * val / this.total, 2);
              return `${this.formatNumber(val, 2)} tCO2e (${percentage}%)`
            }
          }
        },
        grid: {
          show: false,
          padding: { left: -10, right: -10, top: 0, bottom: 0 },
        },
        legend: {
          show: true,
          offsetY: -15,
          position: 'right',
        },
      },
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let args = [{
          years: [year],
          scopes: [3],
          groupKeys: ['year', 'scope', 'category']
        }];

        let data = new FormData()
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return;
        }

        let list = JSON.parse(response.data.data)[0].data;

        // 23-10-11 윤지원: 문경태 팀장님의 요청에 의해 다운스트림 더미 데이터 추가
        // TODO: Scope 3 다운스트림 카테고리 구현 이후 더미 데이터 삭제 요망
        list.push({ category: 9, values: 100000 });
        list.push({ category: 11, values: 5000 });
        list.push({ category: 12, values: 9000 });
        list.push({ category: 14, values: 9000 });
        list.push({ category: 15, values: 18200 });
        let categories = list.map(row => row.category);

        // Calculate total emission
        this.setTotal(list);

        // Set series
        this.setSeriesAndLabels(list, categories);

        // Set colors
        if (this.colors) {
          this.chartOptions.colors = categories.map(cat => this.colors[cat - 1]);
        }
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
    setTotal(list) {
      this.total = list.map(row => row.values).reduce((a, b) => a + b, 0);
    },
    setSeriesAndLabels(list, categories) {
      categories.map(category => {
        const label = this.categoryLabel(category);
        const value = list.find(row => row.category === category).values;
        this.series.push(value);
        this.chartOptions.labels.push(label);
      });
    },
    categoryLabel(category) {
      return category + '. ' + this.$store.getters['ghg/categories'][category - 1].title;
    }
  }
}
</script>
